import { SxProps } from '@mui/material';
import { blue, grey8 } from 'app/components/ThemeProvider/colors';

export const infoText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '26px',
  mb: '12px',
  fontWeight: '600',
};
export const descText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '17px',
  mb: '22px',
  fontWeight: '400',
  color: grey8,
};

export const resendLink: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '15px',
  fontWeight: '400',
  color: blue,
  cursor: 'pointer',
};
